import { CommonPointProps } from '@moleculeone/types';

import { keyframes, styled } from '../../../../stitches.config';
import { Button } from '../../../controls/Button/Button';
import { ButtonGroup } from '../../../controls/Button/ButtonGroup';

const lastUpdatedAnimation = keyframes({
  '0%': { backgroundColor: 'white' },
  '10%': { backgroundColor: '$purple6' },
  '100%': { backgroundColor: 'white' },
});

const ReactionSelection = styled(ButtonGroup, {
  backgroundColor: 'white',
  variants: {
    justUpdated: {
      true: {
        animation: `${lastUpdatedAnimation} 1s ease-in-out`,
      },
    },
  },
});

interface PathButtonGroupProps extends CommonPointProps {
  reactionCount: number;
  justUpdated: boolean;
  value: number;
  onChange: (productId: string, diff: number) => void;
}

export function PathButtonGroup(props: PathButtonGroupProps) {
  const { productId, reactionCount, value, onChange, justUpdated } = props;

  if (reactionCount === 1) {
    return null;
  }

  return (
    <ReactionSelection direction="column" justUpdated={justUpdated}>
      <Button
        size="small"
        weight="outlined"
        text={value}
        icon="arrow_upward"
        disabled={value === 0}
        onClick={() => onChange(productId, value - 1)}
      />
      <Button
        size="small"
        weight="outlined"
        text={reactionCount - value - 1}
        icon="arrow_downward"
        disabled={value === reactionCount - 1}
        onClick={() => onChange(productId, value + 1)}
      />
    </ReactionSelection>
  );
}
